// @ts-ignore
import {Injectable} from '@angular/core';
// @ts-ignore
import {HttpClient} from '@angular/common/http';
// @ts-ignore
import {Observable} from 'rxjs';
import {DuplicarProdutoResultado, OpcaoCampo, ResultadoCopiaTabela} from '../models/produto.model';
import {ProdutoBusca} from '../models/estoque.model';

export const CAMPOS_DUPLICACAO: string[] = [
    'ATIVO',
    'CODPROD',
    'DESCRPROD',
    'GPL_LABEL',
    'AD_SCHEDULEB',
    'AD_ECCN',
    'TIPCONTEST',
    'REFFORN',
    'AD_CONDICAO',
    'CODVOL',
    'CODMARCA',
    'MARCA',
    'CODGRUPOPROD',
    'GPL_MAT_PERIG',
    'GPL_CONTROLADO',
    'GPL_PN_ALTERNATIVO',
    'GPL_CTRL_LIM_PF',
    'GPL_CTRL_LIM_PJ',
    'GPL_MARGEM_CUSTO',
    'GPL_MARGEM_LUCRO',
    'CODLOCALPADRAO',
    'COMPLDESC',
    'REFERENCIA',
    'NCM',
    'PESOBRUTO',
    'PESOLIQ',
    'USOPROD',
    // Campos fiscais de IPI em TGFPRO (copiados do produto modelo, não
    // exibidos na tela — obrigatórios para o DatasetSP.save aceitar o novo produto):
    'CSTIPIENT',      // CST IPI Entrada  (equivale ao "Sit.Trib.IPI Entrada")
    'CSTIPISAI',      // CST IPI Saída
    'CODIPI',         // Código IPI
    'CODENQIPIENT',   // Código de Enquadramento IPI Entrada
    'CODENQIPISAI',   // Código de Enquadramento IPI Saída
    'TEMIPICOMPRA',   // Tem IPI na Compra
    'TEMIPIVENDA',    // Tem IPI na Venda
    'CLASSUBTRIB',    // Classe de Substituição Tributária
    'CODCLASTRIBNAC', // Código Classificação Tributária Nacional
    'AD_CONTROLAFORM', // Controla FORM (S/N)
    'AD_CONTROLACORE', // Controla CORE (S/N)
    'AD_OBSINT',       // Observação Interna
    'AD_OBSTEC',       // Observação Técnica Para o Vendedor
];

export const CAMPO_LABELS: Record<string, string> = {
    CODPROD: 'Codigo (automatico)',
    DESCRPROD: 'Descricao',
    GPL_LABEL: 'Label (USA)',
    COMPLDESC: 'Complemento da Descricao',
    CODMARCA: 'Marca',
    CODVOL: 'Unidade (Volume)',
    REFERENCIA: 'Referencia',
    REFFORN: 'PN (Part Number)',
    GPL_MARGEM_CUSTO: 'Margem de Custo',
    GPL_MARGEM_LUCRO: 'Margem de Lucro',
    NCM: 'NCM',
    CODGRUPOPROD: 'Grupo de Produto',
    GPL_MAT_PERIG: 'Perigoso',
    GPL_CONTROLADO: 'Controlado',
    GPL_PN_ALTERNATIVO: 'PN Alternativo',
    GPL_CTRL_LIM_PF: 'Limite PF',
    GPL_CTRL_LIM_PJ: 'Limite PJ',
    ATIVO: 'Ativo',
    PESOBRUTO: 'Peso Bruto',
    PESOLIQ: 'Peso Liquido',
    USOPROD: 'Uso do Produto',
    CODLOCALPADRAO: 'Local (Estoque)',
    AD_CONDICAO: 'CD (Condition Key)',
    AD_SCHEDULEB: 'Schedule B',
    AD_ECCN: 'ECCN',
    TIPCONTEST: 'Controle de Estoque (Série / Número de Lote)',
    AD_CONTROLAFORM: 'Controla FORM',
    AD_CONTROLACORE: 'Controla CORE',
    AD_OBSINT: 'Obs. Interna',
    AD_OBSTEC: 'Obs. Técnica Para o Vendedor'
};

export function extrairCodigoLocal(valorExibido: string): string {
    const valor = (valorExibido || '').trim();
    if (!valor) {
        return '';
    }
    return valor.split(' - ')[0].trim();
}

// @ts-ignore
@Injectable({providedIn: 'root'})
export class ProdutoService {
    private readonly apiUrl = '/api/sankhya/produto';

    constructor(private readonly http: HttpClient) {
    }

    buscarProdutosModelo(termo: string): Observable<ProdutoBusca[]> {
        return this.http.get<ProdutoBusca[]>(`${this.apiUrl}/modelos`, {params: {termo}});
    }

    /** Tela "Lista de Produtos" -- sem termo, devolve todos os produtos. */
    listarProdutos(termo: string = '', codEmpresa?: string): Observable<ProdutoBusca[]> {
        const params: any = {termo};
        if (codEmpresa) params.codEmpresa = codEmpresa;
        return this.http.get<ProdutoBusca[]>(`${this.apiUrl}/lista`, {params});
    }

    /** Lista de Produtos: uma página por vez, com pesquisa feita no servidor (todas as colunas). */
    listarProdutosPaginado(termo: string, pagina: number, tamanho: number, codEmpresa?: string, completa = false): Observable<{
        sucesso: boolean; erro?: string; total: number; pagina: number; tamanho: number; itens: ProdutoBusca[];
    }> {
        const params: any = {termo, pagina, tamanho};
        if (codEmpresa) params.codEmpresa = codEmpresa;
        if (completa) params.completa = true;
        return this.http.get<{
            sucesso: boolean; erro?: string; total: number; pagina: number; tamanho: number; itens: ProdutoBusca[];
        }>(`${this.apiUrl}/lista-paginada`, {params});
    }

    buscarProdutoCompleto(codprod: number): Observable<{ dados: Record<string, string>; erro?: string }> {
        return this.http.get<{ dados: Record<string, string>; erro?: string }>(`${this.apiUrl}/${codprod}/completo`);
    }

    /** Tela de Edição: grava Label USA, ECCN, Schedule B, Grupo, Perigoso, Controlado, Pesos, NCM e Controla FORM. */
    salvarComplementaresProduto(codprod: string | number, dados: Record<string, string>): Observable<{ sucesso: boolean; mensagem?: string }> {
        return this.http.post<{ sucesso: boolean; mensagem?: string }>(`${this.apiUrl}/${codprod}/complementares`, dados);
    }

    buscarCondicoesVenda(nunota: number): Observable<{
        sucesso: boolean;
        itens: Array<{ SEQUENCIA: string; CODPROD: string; AD_CONDICAO: string }>;
        erro?: string;
    }> {
        return this.http.get<{
            sucesso: boolean;
            itens: Array<{ SEQUENCIA: string; CODPROD: string; AD_CONDICAO: string }>;
            erro?: string;
        }>(`${this.apiUrl}/condicoes-venda/${nunota}`);
    }

    atualizarTipoControle(codprod: number | string, tipContest: 'E' | 'L' | 'N'): Observable<{
        sucesso: boolean;
        mensagem?: string
    }> {
        return this.http.post<{ sucesso: boolean; mensagem?: string }>(`${this.apiUrl}/tipo-controle`, {
            CODPROD: String(codprod),
            TIPCONTEST: tipContest
        });
    }

    traduzirParaIngles(texto: string): Observable<{ traducao: string; sucesso: boolean }> {
        return this.http.post<{ traducao: string; sucesso: boolean }>('/api/sankhya/traducao/pt-en', {texto});
    }

    traduzirParaPortugues(texto: string): Observable<{ traducao: string; sucesso: boolean }> {
        return this.http.post<{ traducao: string; sucesso: boolean }>('/api/sankhya/traducao/en-pt', {texto});
    }

    buscarOpcoesCondicao(): Observable<OpcaoCampo[]> {
        return this.http.get<OpcaoCampo[]>(`${this.apiUrl}/opcoes-condicao`);
    }

    buscarDescricaoLocal(codlocal: string): Observable<string> {
        return this.http.get(`${this.apiUrl}/descricao-local/${encodeURIComponent(codlocal)}`, {responseType: 'text'});
    }

    buscarUnidadesMedida(): Observable<OpcaoCampo[]> {
        return this.http.get<OpcaoCampo[]>(`${this.apiUrl}/unidades-medida`);
    }

    /** Nome/Sigla em inglês de cada unidade (TGFVOL.GPL_NOMEINGLES / GPL_SIGLAINGLES). */
    buscarUnidadesMedidaIngles(): Observable<{ codvol: string; nomeIngles: string; siglaIngles: string }[]> {
        return this.http.get<{ codvol: string; nomeIngles: string; siglaIngles: string }[]>(`${this.apiUrl}/unidades-medida-ingles`);
    }

    buscarMarcas(): Observable<OpcaoCampo[]> {
        return this.http.get<OpcaoCampo[]>(`${this.apiUrl}/marcas`);
    }

    buscarMargensMarca(codMarca: string): Observable<{ custo: string; lucro: string } | null> {
        return this.http.get<{
            custo: string;
            lucro: string
        } | null>(`${this.apiUrl}/margens-marca`, {params: {codMarca}});
    }

    buscarGruposProduto(): Observable<OpcaoCampo[]> {
        return this.http.get<OpcaoCampo[]>(`${this.apiUrl}/grupos`);
    }

    buscarLocais(): Observable<OpcaoCampo[]> {
        return this.http.get<OpcaoCampo[]>(`${this.apiUrl}/locais`);
    }


    buscarDescricaoNcm(codncm: string): Observable<string> {
        return this.http.get(`${this.apiUrl}/descricao-ncm/${encodeURIComponent(codncm)}`, {responseType: 'text'});
    }

    buscarNcms(): Observable<OpcaoCampo[]> {
        return this.http.get<OpcaoCampo[]>(`${this.apiUrl}/ncms`);
    }

    duplicarProduto(dados: Record<string, string>, camposExtras: Record<string, string> = {}): Observable<DuplicarProdutoResultado> {
        return this.http.post<DuplicarProdutoResultado>(`${this.apiUrl}/duplicar`, {
            ...dados,
            _camposExtras: camposExtras
        });
    }

    /**
     * Igual duplicarProduto(), mas cria primeiro o produto espelhado no Aerosys
     * (ADENDO_PECAS) e reaproveita o APE_ID gerado como CODPROD explícito no
     * Sankhya -- mantém APE_ID == CODPROD, invariante usado em Pedido de
     * Compra/Compra/Comparação de Estoque etc. Ver ProdutoAerosysComponent.
     */
    duplicarProdutoComAerosys(dados: Record<string, string>, camposExtras: Record<string, string> = {}): Observable<DuplicarProdutoResultado> {
        return this.http.post<DuplicarProdutoResultado>('/api/produto-aerosys/duplicar', {
            ...dados,
            _camposExtras: camposExtras
        });
    }

    /**
     * Sincroniza (best-effort) uma edição de produto já existente pro Aerosys.
     * Chamar DEPOIS que o Sankhya já salvou com sucesso -- ver gpl-edicao-produtos
     * confirmaSalvar(). Não deve bloquear nem reverter o fluxo se falhar.
     */
    sincronizarEdicaoProdutoAerosys(dados: Record<string, unknown>): Observable<{ sucesso: boolean; erro?: string }> {
        return this.http.post<{ sucesso: boolean; erro?: string }>('/api/produto-aerosys/sincronizar-edicao', dados);
    }

    /** Estoque atual e local (Aerosys) de varios produtos: { "<codprod>": { qtde, local } }. */
    buscarEstoqueAerosysLote(codprods: number[], codEmpSankhya: number): Observable<Record<string, { qtde: number; local: string; core: number }>> {
        return this.http.post<Record<string, { qtde: number; local: string; core: number }>>('/api/produto-aerosys/estoque-lote', { codprods, codEmpSankhya });
    }

    /** Inicia a atualizacao de margens no Aerosys (job). */
    iniciarMargensAerosys(corpo: { codMarca: string; custo: number | null; lucro: number | null }): Observable<any> {
        return this.http.post<any>('/api/produto-aerosys/margens-lote', corpo);
    }

    progressoMargensAerosys(jobId: string): Observable<any> {
        return this.http.get<any>(`/api/produto-aerosys/margens-lote/${jobId}`);
    }

    /** Estoque/local do produto em todas as filiais do Aerosys (modal da Lista de Produtos). */
    estoqueFiliaisAerosys(codprod: string, codEmpSankhya: number): Observable<{
        sucesso: boolean; itens: { empresaId: number; empresa: string; qtde: number; local: string; atual: boolean }[];
    }> {
        return this.http.get<any>(`/api/produto-aerosys/${codprod}/estoque-filiais`, { params: { codEmpSankhya } });
    }

    /** Percentual das gravacoes em segundo plano no Aerosys para o produto recem-cadastrado. */
    progressoAerosys(codprod: string): Observable<{ percentual: number; finalizado: boolean }> {
        return this.http.get<{ percentual: number; finalizado: boolean }>(`/api/produto-aerosys/${codprod}/progresso`);
    }

    /** Ativa/inativa o produto no Sankhya e, best-effort, no Aerosys (ver ProdutoAerosysComponent#alterarAtivo). */
    alterarAtivoProduto(codprod: string, ativo: boolean): Observable<{ sucesso: boolean; erro?: string; avisoAerosys?: string }> {
        return this.http.post<{ sucesso: boolean; erro?: string; avisoAerosys?: string }>('/api/produto-aerosys/ativo', {
            codprod,
            ativo
        });
    }

    /**
     * Sobe a foto do produto pro servidor de documentos do Aerosys
     * (172.16.0.12/cadastros/pecas/) e grava o nome em APE_IMAGEM --
     * best-effort, chamar DEPOIS que a imagem já foi salva no Sankhya com
     * sucesso (ver ProdutoAerosysComponent#salvarImagemAerosys).
     */
    salvarImagemProdutoAerosys(dados: { CODPROD: string; DESCRPROD: string; REFFORN: string; IMAGEM: string })
        : Observable<{ sucesso: boolean; erro?: string; nomeArquivo?: string }> {
        return this.http.post<{ sucesso: boolean; erro?: string; nomeArquivo?: string }>('/api/produto-aerosys/imagem', dados);
    }

    lerImpostosTGFPRO(codprod: string): Observable<Record<string, string>> {
        return this.http.get<Record<string, string>>(`${this.apiUrl}/${codprod}/impostos-tgfpro`);
    }

    copiarImpostosEmpresa(codprodOrigem: string, novoCodprod: string): Observable<ResultadoCopiaTabela> {
        return this.http.post<ResultadoCopiaTabela>(`${this.apiUrl}/copiar/impostos-empresa`, {
            codprodOrigem,
            novoCodprod
        });
    }

    copiarUnidadesAlternativas(codprodOrigem: string, novoCodprod: string): Observable<ResultadoCopiaTabela> {
        return this.http.post<ResultadoCopiaTabela>(`${this.apiUrl}/copiar/unidades-alternativas`, {
            codprodOrigem,
            novoCodprod
        });
    }

    copiarProdutosAlternativos(codprodOrigem: string, novoCodprod: string): Observable<ResultadoCopiaTabela> {
        return this.http.post<ResultadoCopiaTabela>(`${this.apiUrl}/copiar/produtos-alternativos`, {
            codprodOrigem,
            novoCodprod
        });
    }

    copiarProdutosEquivalentes(codprodOrigem: string, novoCodprod: string): Observable<ResultadoCopiaTabela> {
        return this.http.post<ResultadoCopiaTabela>(`${this.apiUrl}/copiar/produtos-equivalentes`, {
            codprodOrigem,
            novoCodprod
        });
    }

    copiarProdutosSugeridos(codprodOrigem: string, novoCodprod: string): Observable<ResultadoCopiaTabela> {
        return this.http.post<ResultadoCopiaTabela>(`${this.apiUrl}/copiar/produtos-sugeridos`, {
            codprodOrigem,
            novoCodprod
        });
    }

    /**
     * Campos da aba "Impostos" de TGFPRO que devem ser copiados para o novo produto.
     * Esses campos fazem parte da própria tabela TGFPRO (não são tabelas separadas),
     * mas não estão em CAMPOS_DUPLICACAO porque precisamos de uma leitura via SQL
     * (SELECT *) para não arriscar erros de campo inválido no CRUDServiceProvider.
     */
    /**
     * Nomes reais das colunas de TGFPRO confirmados via DDL da tabela.
     * Não inclui campos já presentes em CAMPOS_DUPLICACAO (IPI, NCM, CLASSUBTRIB, etc.)
     * nem campos de sistema (CODPROD, DTALTER, NUVERSAO, IMAGEM, CODUSU...) nem
     * campos BLOB/CLOB nem FKs que mudariam de significado num produto novo.
     */
    /**
     * Lista completa de campos da aba Impostos de TGFPRO — confirmada pelo usuário.
     * Exclui: CODPROD (PK), e campos já em CAMPOS_DUPLICACAO
     * (NCM, CLASSUBTRIB, CODIPI, TEMIPIVENDA, TEMIPICOMPRA, CSTIPIENT,
     *  CSTIPISAI, CODENQIPIENT, CODENQIPISAI).
     * O retry automático em _duplicarComRetry descarta silenciosamente qualquer
     * campo que a entidade 'Produto' desta instalação não reconheça.
     */
    private readonly CAMPOS_IMPOSTOS_TGFPRO = [
        // FUST / FUNTTEL
        'CALCFUSTPRO',           // Calcula FUST
        'CALCFUNTTELPRO',        // Calcula FUNTTEL
        // Produto / ROI / Gênero / Serviço
        'PRODINTERNO',           // Produto Interno
        'CODPRODROI',            // Cód. Produto ROI
        'CODGENERO',             // Código Gênero
        'SERVPRESTTER',          // Serviço Prestado a Terceiros
        'CODTAB',                // Código Tabela
        'NUMITEMREA',            // Número Item REA
        // ICMS / ST / MVA / DIFAL
        'PERCREDBASEICMSEFET',   // % Red. Base ICMS Efetiva
        'ALIQICMSINTEFD',        // Alíquota ICMS Interna EFD
        'ALIQGERAL',             // Alíquota Geral
        'MVAPADRAO',             // MVA Padrão
        'MVAAJUSTADO',           // MVA Ajustado
        'TEMICMS',               // Tem ICMS
        'GRUPOICMS',             // Grupo de Tributação ICMS
        'GRUPOICMS2',            // Grupo de Tributação ICMS 2
        'ICMSGERENCIA',          // Considerar débito ICMS nas consultas gerenciais
        'CODICMSFAST',           // Código ICMS Fixo
        'CALCDIFAL',             // Calcular DIFAL
        'TIPOSN',                // Tipo Simples Nacional
        'TIPSUBST',              // Tipo de Substituição Tributária
        // INSS
        'TEMINSS',               // Tem INSS
        'PERCINSS',              // Percentual INSS
        'REDBASEINSS',           // Redução Base INSS
        'OBTSTANTMEDENT',        // Obtém ST/ANT na Med. Ent.
        // CIAP / Outros
        'TEMCIAP',               // Tem CIAP
        'CODAGREGACAO',          // Código de Agregação
        'CNPJFABRICANTE',        // CNPJ do Fabricante
        'INDESCALA',             // Indicador de Escala
        'CODBENEFNAUF',          // Código de Benefício Fiscal na UF
        // FCI / Conteúdo de Importação
        'PERCCMTNAC',            // % Conteúdo Nacional
        'PERCCMTFED',            // % Conteúdo Federal
        'PERCCMTEST',            // % Conteúdo Estadual
        'PERCCMTIMP',            // % Conteúdo Importado
        // ST / NF-e / GTIN
        'CODESPECST',            // Código Específico ST
        'TIPGTINNFE',            // Tipo GTIN NF-e
        'PRODUTONFE',            // Cód. Produto p/ NF-e/NFC-e/CF-e
        'CODBARDIFGTIN',         // Cód. Barras Dif. GTIN
        'CODBARTRIBDIFGTIN',     // Cód. Barras Trib. Dif. GTIN
        // PIS / COFINS / CSLL
        'GRUPOCSSL',             // Grupo CSLL
        'GRUPOPIS',              // Grupo PIS
        'GRUPOCOFINS',           // Grupo COFINS
        'DESDESCCALCPIS',        // Desconta Desconto no Cálculo PIS
        'NATEFDCONTM410M810',    // Nat. EFD Cont. M410/M810
        'TEMCREDPISCOFINSDEPR',  // Tem Crédito PIS/COFINS Depreciação
        // ADRCST
        'PARTICIPAADRCST',       // Participa ADRCST
        'MVAORIGINALADRCST',     // MVA Original ADRCST
        'PRODALIADRCST',         // Produto Aliado DRCST
        // FECOP
        'PRODSUJFECOP',          // Produto Sujeito FECOP
        'ALIQFECOP',             // Alíquota FECOP
        // DRCST
        'MVAORIGINALDRCST',      // MVA Original DRCST
        'DESCPRODDRCST',         // Descreve Produto DRCST
        // CAT 42 / 17-99
        'CONSPRODCAT42',         // Consome Produto CAT 42
        'ALIQINTERNACAT42',      // Alíquota Interna CAT 42
        'CAT1799SPRES',          // CAT 17/99 SPRES
        // Contabilidade
        'CODCTACTB',             // Cód. Conta Contábil
        'CODCTACTB2',            // Cód. Conta Contábil 2
        'CODCTACTB3',            // Cód. Conta Contábil 3
        'CODCTACTB4',            // Cód. Conta Contábil 4
        'CODCTACTBEFD',          // Cód. Conta Contábil EFD
        // REINTEGRA / CPRB
        'ENQREINTEGRA',          // Enquadramento REINTEGRA
        'CODCPRB',               // Código CPRB
        'CODATIVREINTEGRA',      // Código Ativo REINTEGRA
        'AP1RCTEGO',             // AP1 RCT EGO
        // FCI
        'CODFCI',                // Código FCI
        'VLRCOMERC',             // Valor Comercializado
        'VLRPARCIMPEXT',         // Valor Parcela Importação Ext.
        // PRODEPE
        'APURAPRODEPE',          // Apura PRODEPE
        'INDESPPRODEPE',         // Índice Esp. PRODEPE
        // FETHAB
        'ALIQFETHAB',            // Alíquota FETHAB
        'CODVOLFETHAB',          // Cód. Volume FETHAB
        // Campos adicionais presentes no DDL (mantidos por precaução — retry descarta os inválidos)
        'NATBCPISCOFINS',        // Natureza BC PIS/COFINS
        'TEMISS',                // Tem ISS
        'TEMIRF',                // Tem IRF
        'PERCIRF',               // Percentual IRF
        'ORIGPROD',              // Origem do Produto
        'ALIQNAC',               // Alíquota Nacional (FCI)
        'ALIQIMP',               // Alíquota Importação (FCI)
        'PERCCMTMUN',            // % Conteúdo Municipal
        'GERIMPNRETREINFAQ',     // Gera Imp. NRet REINF AQ
        'CONESTORIGPROD',        // Considera Estoque Origem Produto
        'PERCMISTGLP',           // % Mistura GLP
        'PERCMISTGNN',           // % Mistura GNN
        'PERCMISTGNI',           // % Mistura GNI
        'VLRPARTIDAGLP',         // Valor Partida GLP
    ];

    /**
     * Copia os campos da aba "Impostos" que pertencem à própria TGFPRO (não a
     * tabelas filhas) do produto modelo para o produto novo.
     *
     * Usa SELECT * para leitura (evita erro de campo inválido em versões diferentes
     * do Sankhya) e DatasetSP.save com CODPROD para atualizar o produto recém-criado.
     *
     * Se um campo não existir na TGFPRO desta instalação, ele é simplesmente
     * ignorado (indiceColuna retorna -1), não causando erros.
     */
    copiarImpostosTGFPRO(codprodOrigem: string, novoCodprod: string): Observable<{ ok: boolean; erro?: string }> {
        return this.http.post<{ ok: boolean; erro?: string }>(
            `${this.apiUrl}/copiar/impostos-tgfpro`,
            {codprodOrigem, novoCodprod}
        );
    }
}
